import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PriceService {
  private url = environment.api;
  constructor(
    private http: HttpClient,
  ) { }

  getPriceLists() {
    return this.http.get(this.url + "api/erp/inventory/product/price/lists");
  }
}
